import * as React from 'react';

function CaretRightIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.29289 0.292893C2.90237 0.683417 2.90237 1.31658 3.29289 1.70711L7.58579 6L3.29289 10.2929C2.90237 10.6834 2.90237 11.3166 3.29289 11.7071C3.68342 12.0976 4.31658 12.0976 4.70711 11.7071L9.70711 6.70711C10.0976 6.31658 10.0976 5.68342 9.70711 5.29289L4.70711 0.292893C4.31658 -0.0976311 3.68342 -0.0976311 3.29289 0.292893Z" />
    </svg>
  );
}

export default React.memo(CaretRightIcon);
